type ServerErrorsProps = {
  errors?: string[];
};

export function ServerErrors({ errors = [] }: ServerErrorsProps) {
  if (errors.length === 0) {
    return null;
  }

  return (
    <section className="server-errors">
      <ul>
        {errors.map((serverError, i) => (
          <li key={i}>{serverError}</li>
        ))}
      </ul>
    </section>
  );
}
